import {useSettings} from "@montana/containers/settings/settings.container";
import React from "react";
import {SvgIcon} from "../svg-icon";
import clsx from "clsx";
import {MobileAndTabletPortrait, TabletAndLarger} from "@montana/shared/responsive";

type Props = {
    onClick: () => void;
    isOpen: boolean;
};

/**
 * @description Component to display a market button with market information and a language selector.
 *
 * @author HBM
 *
 * @param {Props} props - The props for the component, including an onClick handler.
 *
 * @returns {JSX.Element} The market button component.
 */
export function MarketButton({onClick, isOpen}: Props): JSX.Element {
    const {market, language} = useSettings();
    return (
        <button className="market-button" onClick={onClick}>
            <span>
                <TabletAndLarger>
                    <strong>
                        {`${market?.displayName} ${market?.marketId?.toLowerCase() !== 'en' ? market?.currency : ''} - ${language?.toUpperCase()}`}
                    </strong>
                </TabletAndLarger>
                <MobileAndTabletPortrait>
                    {`${market?.displayName} ${market?.marketId?.toLowerCase() !== 'en' ? market?.currency : ''} - ${language?.toUpperCase()}`}
                </MobileAndTabletPortrait>
            </span>
            <span>
                <SvgIcon
                    className={clsx("select-icon", {
                        "select-icon--open": isOpen
                    })}
                    iconName="chevron_down"
                />
            </span>
        </button>
    );
}
